import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'formatDate',
})
export class FormatDatePipe implements PipeTransform {
  transform(value: string, args?: string): string | null {
    return new DatePipe('en-US').transform(value, args || 'yyyy-MM-dd HH:mm');
  }
}
